import classNames from "classnames";
import { DComponent } from "../DComponent";

export default class CheckBox extends DComponent {
  constructor({
    parent,
    id,
    label,
    labelI18n = "",
    type,
    key = "",
    tabIndex = "",
    checked = true,
    disabled = false,
    isRequired = false,
    className = "",
    onChange = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("CheckBox", {
        "is-disabled": disabled,
      }, className),
      label: label,
      labelI18n: labelI18n ? "[html]" + labelI18n : "",
      name: key,
      tabIndex: tabIndex,
      defaultValue: checked ? "checked" : "",
    });
    this.type = type;
    this.key = key;
    this.isRequired = isRequired;
    this.onChange = onChange;
    this.className = className;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CheckBox");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.isRequired && $(".require", this.element).removeClass("hide");
    $("input", this.element).on("change", (e) => {
      typeof this.onChange == "function" && this.onChange(this.getValue());
    })
  }

  getType() {
    return this.type;
  }

  getKey() {
    return this.key;
  }

  getLabel() {
    return $(".label", this.element).text();
  }

  setLabel(value) {
    $(".label", this.element).text(value);
  }

  getValue() {
    return $("input", this.element).is(':checked');
  }

  setValue(value) {
    $("input", this.element).prop('checked', value);
  }

  clearInput() {
    $("input", this.element).val("");
  }
}